/**
 * created by mgg
 * 表格公用组件
 */
import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {Button, Col, DatePicker, Input, Row, Select, Table, Tabs, Pagination} from "antd";
import moment from "moment";
import {Scrollbars} from "react-custom-scrollbars";
import './style/MyTable.css'

const {Search} = Input;
const {RangePicker} = DatePicker;
const {TabPane} = Tabs;
const {Option} = Select;


export default class MyTable extends Component {
    static defaultProps = {
        columns: [],
        dataSource: [],
        tableHeight:600,
        datetimeList:['今天','昨天','本周', '上周', '本月', '上月'],
        placeholder:'请输入搜索',
    };
    static propTypes = {
        /**
         * 当前所属tab页的key
         */
        tabKey: PropTypes.string,
        /**
         * 当前页最大高度
         */
        tableHeight: PropTypes.number,
        /**
         * 时间选择器可选值
         */
        datetimeList: PropTypes.array,
        /**
         * 时间选择回调(是否展示时间选择器)
         */
        datetime: PropTypes.func,
        /**
         * 一键导出(是否展示一键导出按钮)
         */
        myExport: PropTypes.func,
        /**
         * 搜索(是否展示搜索框)
         */
        mySearch: PropTypes.func,
        /**
         * 搜索提示文本
         */
        placeholder: PropTypes.string,
        /**
         * 表格表头
         */
        columns: PropTypes.array.isRequired,
        /**
         * 表格数据
         */
        dataSource: PropTypes.array.isRequired,
        /**
         * 下拉排序(是否展示下拉选择框)
         */
        mySelect: PropTypes.func,
        /**
         * 下拉排序框可选项
         */
        mySelectOptions: PropTypes.array,
    };

    constructor(props) {
        super(props);
        this.state = {
            endDate:'',// 开始时间
            startDate:'',// 结束时间
            selectPriceDate:'',// 开始时间(用来配置时间选择器选择区间)
        }
    }

    componentWillMount() {
    }

    componentDidMount() {
        if(this.props.datetimeList && this.props.datetimeList.length) {
            let key = this.props.datetimeList[0];
            this.dateChange(key);
        }
    }

    // 日期切换
    dateChange = (key) => {
        if(key === 'RangePicker') return;
        let startDate;
        let endDate;
        // let theEndDate = this.props.datetimeList.indexOf('今天') === -1
        //     ? moment().day(moment().day() - 1).endOf('day')
        //     : moment().endOf('day');
        switch (key) {
            case '今天':
                startDate = moment().startOf("day");
                endDate = moment().endOf('day');
                break;
            case '本周':
                startDate = moment().startOf("week");
                endDate = moment().endOf('day');
                break;
            case '本月':
                startDate = moment().startOf("month");
                endDate = moment().endOf('day');
                break;
            case '昨天':
                startDate =  moment().day(moment().day() - 1).startOf('day');
                endDate = moment().day(moment().day() - 1).endOf('day');
                break;
            case '上周':
                startDate = moment().week(moment().week() - 1).startOf('week');
                endDate = moment().week(moment().week() - 1).endOf('week');
                break;
            case '上月':
                startDate = moment().month(moment().month() - 1).startOf('month');
                endDate = moment().month(moment().month() - 1).endOf('month');
                break;
        }
        this.setState({startDate,endDate});
        this.props.datetime&&this.props.datetime(startDate.valueOf(),endDate.valueOf());
    };

    // 时间选择完毕
    timeChange = (data,str) => {
        this.setState({
            selectPriceDate :'',
            startDate:data[0],
            endDate:data[1],
        });
        this.props.datetime&&this.props.datetime(data[0].valueOf(),data[1].valueOf());
    };

    // 选择时间开始
    timeStart = (date) => {
        this.setState({selectPriceDate:date[0]})
    };

    // 时间选择器禁用规范
    disabledPriceRangeDate = (current) => {
        let theEndDate =this.props.datetimeList.indexOf('今天') === -1
            ?moment().day(moment().day() - 1).endOf('day')
            :moment().endOf('day');
        if(this.state.selectPriceDate) {
            let selectV = this.state.selectPriceDate;
            return  current > moment(selectV).add(1, "years")
                || current < moment(selectV).subtract(1, "years")
                || current > theEndDate;
        } else {
            return current > theEndDate;
        }
    };

    render() {
        let {tableHeight, mySearch, datetimeList, myExport, columns, dataSource, mySelect, placeholder, mySelectOptions, datetime} = this.props;
        return (
            <div style={{height: '100%'}}>
                <div style={{height: 90}}>
                    <Row>
                        {/*搜索*/}
                        <Col span={12} style={{height:40,display:'flex',alignItems:'center'}}>
                            {mySearch ? <Search
                                placeholder={placeholder}
                                allowClear
                                enterButton="查询"
                                size="default"
                                onSearch={mySearch}
                                style={{
                                    marginLeft: 12,
                                    width: 250,
                                    marginRight: 40
                                }}
                            /> : null}
                            {mySelect ? <Select
                                placeholder={'请选择排序'}
                                style={{width: 186, marginLeft: 12}}
                                onSelect={mySelect}
                            >
                                {mySelectOptions && mySelectOptions.length ? (
                                    mySelectOptions.map((item, index) => (
                                        <Option key={index} value={item}>{item}</Option>
                                    ))
                                ) : null}
                            </Select> : null}
                        </Col>
                        {/*选择时间*/}
                        <Col
                            className={'myTableBox'}
                            span={12}
                            style={{display: "flex", justifyContent: "flex-end"}}>
                            {datetime
                                ? (<Tabs defaultActiveKey={datetimeList && datetimeList[0] || '0'} size={'small'}
                                         onChange={this.dateChange} type={'card'}>
                                    {datetimeList && datetimeList.length
                                        ? datetimeList.map((item, index) => {
                                            return (
                                                <TabPane tab={item} key={item} />
                                            )
                                        })
                                        : null}
                                    <TabPane
                                        tab={<div>
                                            <RangePicker value={[this.state.startDate, this.state.endDate]}
                                                         dateFormat = 'YYYY-MM-DD'
                                                         allowClear={false}
                                                         onChange={this.timeChange}
                                                         onCalendarChange={this.timeStart}
                                                         disabledDate={this.disabledPriceRangeDate}
                                                         defaultValue={[moment(this.state.startDate), moment(this.state.endDate)]}
                                            />
                                        </div>}
                                        key={'RangePicker'}
                                    />
                                </Tabs>)
                                : null}
                        </Col>
                    </Row>
                    {myExport ? <Button type="primary" onClick={myExport}
                                        style={{width: 90, marginLeft: 12,marginTop:12}}>导出</Button> : null}
                </div>
                <div style={{height: tableHeight-90}}>
                    <Scrollbars style={{height: '100%'}}>
                        <Table
                            columns={columns}
                            dataSource={dataSource}
                            pagination={false}
                            bordered
                            style={{margin: 10}}
                        />
                    </Scrollbars>
                </div>
            </div>
        )
    }
}